import * as React from 'react';
import { FixedSizeList, FixedSizeListProps } from 'react-window';

export default function VirtualizedList({
  width = 360,
  height = 400,
  itemSize = 46,
  itemCount = 200,
  overscanCount = 5,
  ...rest
}: FixedSizeListProps) {
  return (
    <FixedSizeList
      height={height}
      width={width}
      itemSize={itemSize}
      itemCount={itemCount}
      overscanCount={overscanCount}
      {...rest}
    />
  );
}
